import login_image from "./login_image.png"
import profile_image from "./profile_image.jpg"
import one_solutions from "./one_solutions.png"
import popup_bg from "./popup_bg.jpg"
import login_bg from "./login_bg.jpeg"
import image_avatar from "./image_avatar.png"
import signup_image from "./signup_image.png"
import signup_bg from "./signup_bg.jpg"
import one_solutions_signup from "./one_solutions_signup.png"
import profile_side_image from "./profile_side_image.jpg"
import job_list_bg from "./job_list_bg.jpg"
import job_uploader_image from "./job_uploader_image.png"
import reset_image from "./reset_image.jpg"
import whatsapp_chat_bg from "./whatsapp_chat_bg.jpg"
import Logo from "./Logo.png"
import digital_marketing from "./digital_marketing.png"

export const assests = {
    login_image,
    profile_image,
    one_solutions,
    popup_bg,
    job_list_bg,
    login_bg,
    image_avatar,
    signup_image,
    signup_bg,
    one_solutions_signup,
    profile_side_image,
    job_uploader_image,
    reset_image,
    whatsapp_chat_bg, 
    Logo,
    digital_marketing
}